import React, { createContext, useContext, useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';

const ThemeContext = createContext(null);
const KEY = 'dealrun_theme';

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem(KEY) || 'dark');

  useEffect(() => {
    document.documentElement.classList.toggle('light', theme === 'light');
    document.documentElement.style.colorScheme = theme;
    localStorage.setItem(KEY, theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'));
  return <ThemeContext.Provider value={{ theme, toggle, isLight: theme === 'light' }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);

export const ThemeToggle = ({ withLabel = false, className = '' }) => {
  const { isLight, toggle } = useTheme();
  return (
    <button onClick={toggle} data-testid="theme-toggle" aria-label={isLight ? 'Passer en mode sombre' : 'Passer en mode clair'} title={isLight ? 'Mode sombre' : 'Mode clair'}
      className={`flex items-center gap-2 rounded-full hover:bg-white/10 transition-colors text-[#B3B3B3] hover:text-white ${withLabel ? 'px-4 py-3 rounded-md text-sm font-semibold w-full' : 'w-10 h-10 justify-center'} ${className}`}>
      <span className="relative w-5 h-5">
        <Sun size={18} className={`absolute inset-0 transition-all duration-300 ${isLight ? 'opacity-0 rotate-90 scale-50' : 'opacity-100 rotate-0 scale-100'}`} />
        <Moon size={18} className={`absolute inset-0 transition-all duration-300 ${isLight ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 -rotate-90 scale-50'}`} />
      </span>
      {withLabel && (isLight ? 'Mode sombre' : 'Mode clair')}
    </button>
  );
};
